import { useState } from 'react';

const carouselItems = [
  {
    title: '暑期档必看：十大高分新片',
    desc: '编辑部精选今夏最值得期待的院线级大片，从动作巨制到温情文艺，总有一部适合你。每部均附独家看点解析。',
    tag: '编辑精选',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20blockbuster%20collage%20with%20warm%20amber%20spotlight%2C%20action%20movie%20aesthetic%2C%20soft%20coral%20gradients%2C%20dramatic%20golden%20hour%20lighting%2C%20rich%20cinematic%20textures%2C%20elegant%20composition&width=800&height=480&seq=carousel-01&orientation=landscape'
  },
  {
    title: '悬疑迷的盛宴：烧脑神作盘点',
    desc: '从国产精品到海外佳作，精选20部让你猜不到结局的高分悬疑片。反转再反转，每一帧都是细节。',
    tag: '专题策划',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20mystery%20thriller%20theme%20with%20warm%20dramatic%20lighting%2C%20shadowy%20detective%20aesthetic%2C%20soft%20coral%20and%20amber%20tones%2C%20suspenseful%20atmosphere%2C%20rich%20film%20noir%20textures%2C%20elegant%20composition&width=800&height=480&seq=carousel-02&orientation=landscape'
  },
  {
    title: '经典港片修复计划：重温黄金时代',
    desc: '多部经典香港电影经过4K修复重新上线，从武侠到警匪，从喜剧到文艺，致敬那个辉煌的光影年代。',
    tag: '经典重现',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20Hong%20Kong%20classic%20film%20aesthetic%20with%20warm%20nostalgic%20lighting%2C%20vintage%20cinema%20vibe%2C%20soft%20golden%20and%20coral%20gradients%2C%20retro%20movie%20theater%20atmosphere%2C%20rich%20textures%2C%20elegant%20composition&width=800&height=480&seq=carousel-03&orientation=landscape'
  },
  {
    title: '纪录片专区：看见真实的世界',
    desc: '自然、人文、科技、历史……高分纪录片专题已上线。用镜头探索世界，每一部都值得静心观看。',
    tag: '新专区',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20documentary%20nature%20scene%20with%20warm%20golden%20hour%20lighting%2C%20vast%20landscape%20aesthetic%2C%20soft%20coral%20sunset%20gradients%2C%20awe-inspiring%20atmosphere%2C%20rich%20natural%20textures%2C%20elegant%20composition&width=800&height=480&seq=carousel-04&orientation=landscape'
  },
  {
    title: '追剧日历：本月连载时间表全览',
    desc: '一图掌握本月所有在追热播剧的更新节奏，再也不怕错过更新。附每日推荐观影时段与最佳观看顺序。',
    tag: '追更指南',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20calendar%20planner%20theme%20with%20warm%20amber%20lighting%2C%20organized%20schedule%20aesthetic%2C%20soft%20coral%20gradients%2C%20clean%20modern%20layout%20vibe%2C%20rich%20textures%2C%20elegant%20cinematic%20composition&width=800&height=480&seq=carousel-05&orientation=landscape'
  },
];

export default function Carousel() {
  const [imgErrors, setImgErrors] = useState<Record<number, boolean>>({});

  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">专题聚焦</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">深度策划的影视专题内容，带你发现更多精彩</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.slice(0, 3).map((item, idx) => (
            <div
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative aspect-[16/9] bg-background-200 overflow-hidden">
                {!imgErrors[idx] ? (
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={() => setImgErrors((prev) => ({ ...prev, [idx]: true }))}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <i className="ri-image-line text-4xl text-foreground-300"></i>
                  </div>
                )}
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2.5 py-1 rounded-full bg-primary-500 text-background-50 whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
          {carouselItems.slice(3).map((item, idx) => (
            <div
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 lg:col-span-3"
            >
              <div className="flex flex-col md:flex-row">
                <div className="relative w-full md:w-[320px] shrink-0 aspect-[16/9] md:aspect-auto bg-background-200 overflow-hidden">
                  {!imgErrors[idx + 3] ? (
                    <img
                      src={item.img}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      onError={() => setImgErrors((prev) => ({ ...prev, [idx + 3]: true }))}
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <i className="ri-image-line text-4xl text-foreground-300"></i>
                    </div>
                  )}
                  <div className="absolute top-3 left-3">
                    <span className="text-xs px-2.5 py-1 rounded-full bg-primary-500 text-background-50 whitespace-nowrap">{item.tag}</span>
                  </div>
                </div>
                <div className="flex-1 p-4 md:p-6 flex flex-col justify-center">
                  <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}